function DazContract721XC(address, cfg, proxyAddress = null) {
    address = dazethutil.toLower(address);
    this.config = cfg || {};
    this.address = address;
    this.proxyAddress = proxyAddress;
    const ct = this.config.contracts.list[address];
    this.name = ct.name;
    if (ct.types) {
        this.types = ct.types;
    } else {
        this.baseImageURI = ct.image;
        this.baseThumbURI = ct.thumb;
    }
    this.contractData = false;
}

DazContract721XC.prototype.getName = function (token) {
    if (this.types && this.types[token]) {
        return this.types[token].name;
    }
    return this.name;
}

DazContract721XC.prototype.getImageURL = function (token) {
    if (this.types && this.types[token]) {
        return this.types[token].image;
    }
    return this.baseImageURI + token;
}

DazContract721XC.prototype.getThumbURL = function (token) {
    if (this.types && this.types[token]) {
        return this.types[token].thumb;
    }
    return this.baseThumbURI + token;
}

DazContract721XC.prototype.getMetadataURL = async function (token) {
    return "";
}

DazContract721XC.prototype.load = async function (address) {
    if (!window.dazXC) {
        throw 'Not cross chain c721';
    }
    if (this.contractData !== false) {
        return this.contractData;
    }
    const xc = window.dazXC();
    const data = xc.data({
        who: dazethutil.me(),
        contract: this.address,
        now: (new Date).getTime()
    })
    return fetch(this.config.baseUrl + "/nft-api/nfp/gen1/bridge/erc721", {
        method: 'POST',
        mode: 'cors',
        body: (new URLSearchParams(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    }).then((response) => {
        if (!response.ok) {
            throw "could not load";
        }
        return response.json();
    }).then(json => {
        this.contractData = {
            BalanceOf: json.BalanceOf,
            Tokens: json.Tokens,
        }
        return this.contractData;
    });
}

DazContract721XC.prototype.balanceOf = async function (address) {
    return this.load(address).then(cd => {
        return cd.BalanceOf;
    });
}

DazContract721XC.prototype.tokenOfOwnerByIndex = async function (address, index) {
    if (index < 0) {
        return 0;
    }
    return this.load(address).then(cd => {
        if (index >= cd.Tokens.length) {
            return 0;
        }
        return cd.Tokens[index].toString();
    });
}

DazContract721XC.prototype.getMyTokenIDs = async function (address) {
    return this.load(address).then(cd => {
        return cd.Tokens;
    });
}
